import React from "react";
import LoginPage from "../pages/login/Login.Page";

function LayoutNoauth() {
  return (
    <>
      <LoginPage />
    </>
  );
}

export default LayoutNoauth;
